<template>
  <div v-if="$mq === 'sm' || $mq === 'xs'">
    <div class="nav justify-content-center main-menu main-menu--always-bordered" v-if="!newProfile">
      <span
        class="nav-item main-menu__item-wrapper"
        :class="{ active: currentTab === 'own' }"
        @click="currentTab = 'own'"
      >
        <span class="main-menu__item nav-link">Я</span>
      </span>
      <span
        class="nav-item main-menu__item-wrapper"
        :class="{ active: currentTab === 'family' }"
        @click="currentTab = 'family'"
      >
        <span class="main-menu__item nav-link">Семья</span>
      </span>
    </div>

    <div class="d-flex justify-content-center mt-4" v-if="currentTab === 'own'">
      <user-profile-block :user="getUser" :profile="getCurrentProfile"></user-profile-block>
    </div>
    <div class="d-flex justify-content-center flex-column align-items-center" v-else-if="getFamilyProfile">
      <div class="main-menu__wrapper" id="profile-tabs-wrapper" v-if="!newProfile">
        <div class="nav main-menu mb-4 pl-3">
          <span
            v-for="profile in getProfiles"
            :key="profile.id"
            class="nav-item main-menu__item-wrapper px-3"
            :class="{ active: currentFamilyId === profile.id }"
            @click="currentFamilyId = profile.id"
            :id="`profile-${profile.id}`"
          >
            <span class="main-menu__item nav-link">{{ profile.name }}</span>
          </span>
          <span
            class="nav-item main-menu__item-wrapper k-profile__add-item px-2 mr-3"
            @click="createEmptyProfile"
          >
            <span class="main-menu__item nav-link d-flex">
              <svg class="mr-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="7.11133" width="1.77778" height="16" rx="0.888889" fill="white"/>
                <rect x="16" y="7.10938" width="1.77778" height="16" rx="0.888889" transform="rotate(90 16 7.10938)" fill="white"/>
              </svg>

              Добавить
            </span>
          </span>
        </div>
      </div>
      <user-profile-block v-if="!newProfile && currentFamilyId" :profile="getFamilyProfile"></user-profile-block>
      <div v-if="newProfile">
        <user-profile-block
          class="k-profile__item mt-3"
          :profile="newProfile"
          :editingMode="true"
          @edit="editProfileHandler"
          @remove-new="cleanNewProfile"
        ></user-profile-block>
      </div>
    </div>
  </div>
  <div v-else class="k-profile-wrapper" id="k-profile-wrapper">
    <div class="k-profile__my-wrapper" v-if="getCurrentProfile">
      <div class="k-profile__title">Мой профиль</div>
      <div class="k-profile__items">
        <user-profile-block :user="getUser" :profile="getCurrentProfile"></user-profile-block>
      </div>
    </div>
    <div class="k-profile__family-wrapper" v-if="getProfiles">
      <div class="k-profile__title d-flex">
        Моя семья
        <div class="k-profile-item__add ml-2" @click="createEmptyProfile">+</div>
      </div>
      <div class="k-profile__items">
        <user-profile-block
          class="k-profile__item"
          :profile="profile"
          v-for="profile in getProfiles"
          :key="profile.id"
        ></user-profile-block>

        <user-profile-block
          class="k-profile__item"
          :profile="newProfile"
          :editingMode="true"
          v-if="newProfile"
          @edit="editProfileHandler"
          @remove-new="cleanNewProfile"
        ></user-profile-block>
      </div>
    </div>
  </div>
</template>

<script>
import UserProfileBlock from "@/components/UserProfileBlock";
import { mapGetters } from "vuex";

export default {
  name: "UserProfile",
  components: {
    UserProfileBlock
  },
  data() {
    return {
      newProfile: null,
      currentTab: 'own',
      currentFamilyId: null,
    };
  },
  watch: {
    getProfiles(value) {
      if ((value.length > 0 && !this.currentFamilyId) || (!value.some(el => el.id === this.currentFamilyId) && value.length > 0)) {
        this.currentFamilyId = value[0].id;
      }

      if (value.length === 0) {
        this.currentFamilyId = null
        this.newProfile = null
      }
    },
    /*
    currentFamilyId(value) {
      document.getElementById('profile-tabs-wrapper').scrollLeft = document.getElementById(`profile-${value}`).offsetLeft;
    }
    */
  },
  mounted() {
    if ((this.getProfiles.length > 0 && !this.currentFamilyId) || (!this.getProfiles.some(el => el.id === this.currentFamilyId) && this.getProfiles.length > 0)) {
      this.currentFamilyId = this.getProfiles[0].id;
    }

    if (this.$route.params.id && this.isMobile && this.getProfiles.length > 0) {
      this.navigateToProfile(this.$route.params.id);
    } 

    // Keep native wheel/touch scrolling on both axes; never hijack vertical wheel input.

    // this.navigateToProfile();
  },
  computed: {
    ...mapGetters(["getCurrentProfile", "getProfiles", "getUser"]),
    getFamilyProfile() {
      return this.getProfiles.find(el => el.id === this.currentFamilyId) || {}
    },
    isMobile() {
      return this.$mq === 'xs' || this.$mq === 'sm';
    },
  },
  methods: {
    async navigateToProfile(id) {
      if (id === this.getCurrentProfile.id) return;

      this.currentTab = 'family';
      await this.$nextTick();

      document.getElementById(`profile-${id}`).scrollIntoView();
      document.getElementById('profile-tabs-wrapper').scrollLeft = document.getElementById(`profile-${id}`).offsetLeft;
      this.currentFamilyId = id;

      this.$router.replace({ params: {} })
    },
    createEmptyProfile() {
      this.newProfile = {};
    },
    editProfileHandler(profile) {
      if (!profile.id) {
        this.cleanNewProfile();
      }
    },
    cleanNewProfile() {
      this.newProfile = null;
    }
  }
};
</script>

<style scoped lang="scss">
.k-profile__family-wrapper .k-profile__title {
  margin-left: 36px;
}

.k-profile__item {
  margin-left: 36px;
}

.k-profile-item__add {
  background: #9dc43b;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
  -webkit-border-radius: 24px;
  -moz-border-radius: 24px;
  border-radius: 24px;
  color: #fff;
  cursor: pointer;
  font-size: 24px;
  line-height: 22px;
  height: 24px;
  right: 50px;
  text-align: center;
  width: 24px;
}
.k-profile__add-item {
  border: unset;
  background: #9DC43B;
  
  span {
    color: #fff !important;
    opacity: 1;
  }
}
.main-menu--always-bordered {
  border-bottom: 2px solid #E4E4E4;
  width: 100%;
  .main-menu__item-wrapper {
    width: 50%;
    margin-right: 0;
    display: flex;
    justify-content: center !important;
    border: unset;
    &.active {
      background: unset;
      .main-menu__item {
        border-bottom: 2px solid #F68C1E;
      }
    }
    .main-menu__item {
      color: #000000;
      width: 100%;
      display: flex;
      justify-content: center !important;
    }
  }
}

@media (max-width: 797.98px) {
  .k-profile__item {
    margin-left: 0;
  }
}
</style>
